import { render, staticRenderFns } from "./BitsBeeView.vue?vue&type=template&id=4b56adf2&"
import script from "./BitsBeeView.vue?vue&type=script&lang=ts&"
export * from "./BitsBeeView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports